<div class="toolbar">
  <q9-toolbar>
    <div q9-left-content>
      <q9-section>
        <span title [translate]="title"></span>
        <span content *ngIf="node">{{ 'DA.ROOT_ITEM' | translate: {name: node?.name} }}</span>
        <span content *ngIf="!node && multiple">
          {{ 'DA.ROOT_ITEM' | translate: {name: 'multiple'} }}
        </span>
      </q9-section>
    </div>

    <div q9-right-content>
      <ng-content select=".top"></ng-content>

      <mat-divider *ngIf="showTopDivider" vertical="true"></mat-divider>

      <ng-container *ngIf="showShareRefModelButton">
        <q9-primary-button (click)="onShareRefModel()">
          {{ 'CORE.USER_ACCESS.SHARE_BTN' | translate }}
        </q9-primary-button>
      </ng-container>

      <q9-theme-switcher></q9-theme-switcher>
      <q9-reports (reportAction)="showSavedReports($event)"></q9-reports>
      <q9-notifications></q9-notifications>
      <q9-profile-menu></q9-profile-menu>
    </div>
  </q9-toolbar>

  <q9-toolbar>
    <div q9-left-content>
      <button
        mat-button
        class="home-button"
        (click)="goToRefModelsList()"
        matTooltipPosition="below"
        [matTooltip]="'TOOLTIPS.OPEN_REFMODELS_LIST' | translate">
        <mat-icon inline="true" matPrefix svgIcon="elements_logo-icon"></mat-icon>
        {{ 'SEARCH.TOOLBAR_TITLE' | translate }}
      </button>

      <mat-divider vertical="true"></mat-divider>

      <ng-content select=".second"></ng-content>
    </div>

    <div q9-right-content>
      <ng-content select="[reloadTreeButton]"></ng-content>
      <ng-content select="[resetFiltersBtn]"></ng-content>
    </div>
  </q9-toolbar>
</div>
